import { MenuItemType } from "./menuitem.type.enum";
import { FunctionSummaryModel } from "../functioninfo/functionSummary.model";

export class MenuItem {
    public id: number;
    public menuItemType: MenuItemType;
    public itemOrder: number;
    public displayText: string;
    public iconUrl: string;
    public parentMenuItemId?: number;
    public functionId?: number;

    public functionViewModel: FunctionSummaryModel;

    public childItems: MenuItem[];

  constructor() {
        this.childItems = [];
        this.itemOrder = 1;
        this.functionViewModel = new FunctionSummaryModel();
    }
}
